import { inject, Injectable } from '@angular/core'
import { Store, Action, select } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as StaffSelectors from './staff.selectors'

@Injectable({
  providedIn: 'root',
})
export class StaffFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(StaffSelectors.selectStaffLoaded))
  allSiteAnnouncements$ = this.store.pipe(select(StaffSelectors.selectAllStaff))
  selectedSiteAnnouncement$ = this.store.pipe(select(StaffSelectors.selectEntity))
  exportReportLoaded$ = this.store.pipe(select(StaffSelectors.selectExportReportLoaded))

  dispatch(action: Action) {
    this.store.dispatch(action)
  }
}
